<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5 3.5C19.7091 3.5 21.5 5.29086 21.5 7.5V17.5C21.5 19.7091 19.7091 21.5 17.5 21.5H7.5C5.29086 21.5 3.5 19.7091 3.5 17.5V7.5C3.5 5.29086 5.29086 3.5 7.5 3.5H17.5ZM15.5 5H17.5C18.8807 5 20 6.11929 20 7.5V10.1818H15.5V5ZM14 20H7.5C6.11929 20 5 18.8807 5 17.5V7.5C5 6.11929 6.11929 5 7.5 5H14L14 20ZM15.5 20H17.5C18.8807 20 20 18.8807 20 17.5V11.6818H15.5L15.5 20Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
  </svg>
</template>

<script setup lang="ts"></script>
